import React from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

export default function ImageCard(props) {
  const { t, i18n } = useTranslation();

  let image = props.image;
  const history = useHistory();

  const colorImage = () => {
    history.push(`/coloring-page/${image.id}`);
  };

  return (
    <div className="image-card" onClick={colorImage}>
      <h4>{i18n.language === "en"
              ? image.nameEN
              : i18n.language === "fr"
              ? image.nameFR
              : i18n.language === "es"
              ? image.nameES
              : ""}</h4>
      <img alt="national park" className="new-image" src={image.src} />
      <button onClick={colorImage}>{t("description.Color me")}</button>
    </div>
  );
}
